import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import CommonLayout from '../../layouts/CommonLayout';
import MeetingMeetingApplicationContainer from '../../containers/MeetingMeetingApplicationContainer';
import { getMeetingMeetingApplications } from '../../../api/MeetingApplicationApi';
import useLoadingStore from '../../../store/loadingStore';
import { IoDocumentTextOutline, IoPeopleOutline } from 'react-icons/io5';

const MeetingMeetingApplicationListPage = () => {
    const { meetingId } = useParams();
    const [applications, setApplications] = useState([]);
    const [meetingInfo, setMeetingInfo] = useState({
        minCapacity: 0,
        currentMemberCount: 0,
        maxCapacity: 0
    });
    const { setIsLoading } = useLoadingStore();

    const loadApplications = async () => {
        try {
            setIsLoading(true);
            const response = await getMeetingMeetingApplications(meetingId);
            setApplications(response.meetingMeetingApplicationDtoList);
            setMeetingInfo({
                minCapacity: response.minCapacity,
                currentMemberCount: response.currentMemberCount,
                maxCapacity: response.maxCapacity
            });
        } catch (error) {
            console.error('신청서 목록 조회 실패:', error);
            alert('신청서 목록을 불러오는 중 오류가 발생했습니다.');
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        loadApplications();
    }, [meetingId]);

    const handleApplicationUpdate = () => {
        loadApplications(); // 승인/거절 후 리스트 새로고침
    };

    return (
        <CommonLayout title="신청서 관리">
            <div className="max-w-lg mx-auto">
                <div className="p-4">
                    {/* 인원 정보 */}
                    <div className="bg-white border border-gray-200 rounded-lg p-4 mb-4">
                        <div className="flex items-center mb-3">
                            <IoPeopleOutline size={20} className="text-amber-500 mr-2" />
                            <h2 className="text-md font-semibold text-gray-900">모임 인원</h2>
                        </div>
                        <div className="grid grid-cols-3 gap-4 text-center">
                            <div>
                                <p className="text-sm text-gray-500">최소 인원</p>
                                <p className="text-lg font-semibold text-gray-900">{meetingInfo.minCapacity}명</p>
                            </div>
                            <div>
                                <p className="text-sm text-gray-500">현재 인원</p>
                                <p className="text-lg font-semibold text-amber-500">{meetingInfo.currentMemberCount}명</p>
                            </div>
                            <div>
                                <p className="text-sm text-gray-500">최대 인원</p>
                                <p className="text-lg font-semibold text-gray-900">{meetingInfo.maxCapacity}명</p>
                            </div>
                        </div>
                    </div>

                    {applications.length === 0 ? (
                        <div className="flex flex-col items-center justify-center h-64 text-gray-500">
                            <IoDocumentTextOutline size={64} className="text-gray-400 mb-4" />
                            <p className="text-center">
                                신청서가 없습니다
                            </p>
                        </div>
                    ) : (
                        <div>
                            <p className="text-sm text-gray-600 mb-4">
                                총 {applications.length}개의 신청서가 있습니다
                            </p>
                            {applications.map((application) => (
                                <MeetingMeetingApplicationContainer
                                    key={application.id}
                                    application={application}
                                    meetingId={meetingId}
                                    onUpdate={handleApplicationUpdate}
                                />
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </CommonLayout>
    );
};

export default MeetingMeetingApplicationListPage;
